import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import PostCard from "@/components/community/PostCard";

export default function Profile() {
  const { userId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get(`/users/${userId}`)
      .then(({ data }) => setData(data))
      .catch(() => setData(false));
  }, [userId]);

  if (data === false)
    return <main className="min-h-screen pt-40 text-center text-white/40">No such Forger.</main>;
  if (!data) return <main className="min-h-screen pt-40 text-center text-white/30">Loading…</main>;

  const initials = (data.user.name || "F").slice(0, 2).toUpperCase();

  return (
    <main data-testid="profile-page" className="min-h-screen pt-28 pb-24">
      <div className="mx-auto w-[min(1080px,calc(100%-32px))]">
        <div className="flex items-center gap-5 mb-12">
          {data.user.picture ? (
            <img
              src={data.user.picture}
              alt={data.user.name}
              className="w-16 h-16 rounded-full border border-white/15"
            />
          ) : (
            <div className="w-16 h-16 rounded-full border border-forge/40 bg-forge/10 grid place-items-center display text-lg text-forge">
              {initials}
            </div>
          )}
          <div>
            <h1 data-testid="profile-name" className="headline text-3xl sm:text-4xl">
              {data.user.name}
            </h1>
            <p className="text-xs text-white/35 mt-1">{data.posts.length} posts</p>
          </div>
        </div>

        {data.posts.length === 0 ? (
          <p className="text-sm text-white/30">Nothing forged publicly yet.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-4" data-testid="profile-posts">
            {data.posts.map((post) => (
              <PostCard key={post.post_id} post={post} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
